export const FETCH_CORPORATE_AUTOCOMPLETE = 'src/Corporate/action/Fetch_Corporate_Autocomplete';
export const FETCH_CORPORATE_AUTOCOMPLETE_SUCCESS = 'src/Corporate/action/Fetch_Corporate_Autocomplete_Success';
export const FETCH_CORPORATE_AUTOCOMPLETE_FAILURE = 'src/Corporate/action/Fetch_Corporate_Autocomplete_Failure';

export const fetchCorporateAutocomplete = (searchText) => {
    console.log("searchText", searchText);
    return {
        type: FETCH_CORPORATE_AUTOCOMPLETE,
        data: searchText
    }
}

export const fetchCorporateAutocompleteSuccess = (data) => {
    return {
        type: FETCH_CORPORATE_AUTOCOMPLETE_SUCCESS,
        data
    }
}

export const fetchCorporateAutocompleteFailure = (data) => {
    return {
        type: FETCH_CORPORATE_AUTOCOMPLETE_FAILURE,
        data
    }
}


// Constants
export const FETCH_PRODUCTS_BY_CORPORATE = 'src/Product/action/Fetch_Products_By_Corporate';
export const FETCH_PRODUCTS_BY_CORPORATE_SUCCESS = 'src/Product/action/Fetch_Products_By_Corporate_Success';
export const FETCH_PRODUCTS_BY_CORPORATE_FAILURE = 'src/Product/action/Fetch_Products_By_Corporate_Failure';


export const fetchProductsByCorporate = (corporateId) => {
    console.log("Triggering product fetch for corporateId:", corporateId);
    return {
        type: FETCH_PRODUCTS_BY_CORPORATE,
        payload: { corporateId }
    };
};


export const fetchProductsByCorporateSuccess = (data) => {
    return {
        type: FETCH_PRODUCTS_BY_CORPORATE_SUCCESS,
        data
    };
};


export const fetchProductsByCorporateFailure = (error) => {
    return {
        type: FETCH_PRODUCTS_BY_CORPORATE_FAILURE,
        error
    };
};

export const DOWNLOAD_BULK_REPORT_EXCEL = 'DOWNLOAD_BULK_REPORT_EXCEL';
export const DOWNLOAD_BULK_REPORT_EXCEL_SUCCESS = 'DOWNLOAD_BULK_REPORT_EXCEL_SUCCESS';
export const DOWNLOAD_BULK_REPORT_EXCEL_FAILURE = 'DOWNLOAD_BULK_REPORT_EXCEL_FAILURE';

export const downloadBulkReportExcel = (payload) => ({
    type: DOWNLOAD_BULK_REPORT_EXCEL,
    payload, // Expecting { corporateId, status, productIds, startDate, endDate }
});


export const downloadBulkReportExcelSuccess = () => ({
    type: DOWNLOAD_BULK_REPORT_EXCEL_SUCCESS,
});

export const downloadBulkReportExcelFailure = (error) => ({
    type: DOWNLOAD_BULK_REPORT_EXCEL_FAILURE,
    error,
})

export const UPDATE_BULK_CASES = 'UPDATE_BULK_CASES';
export const UPDATE_BULK_CASES_SUCCESS = 'UPDATE_BULK_CASES_SUCCESS';
export const UPDATE_BULK_CASES_FAILURE = 'UPDATE_BULK_CASES_FAILURE';

export const updateBulkCases = (formData) => ({
    type: UPDATE_BULK_CASES,
    payload: formData
});

export const updateBulkCasesSuccess = (message) => ({
    type: UPDATE_BULK_CASES_SUCCESS,
    payload: message 
});

export const updateBulkCasesFailure = (message) => ({
    type: UPDATE_BULK_CASES_FAILURE,
    payload: message
});

export const RESET_BULK_UPLOAD_STATE = 'RESET_BULK_UPLOAD_STATE';

export const resetBulkUploadState = () => ({
    type: RESET_BULK_UPLOAD_STATE,
});

export const FETCH_BULK_CASE_UPDATION_LIST = 'FETCH_BULK_CASE_UPDATION_LIST';
export const FETCH_BULK_CASE_UPDATION_LIST_SUCCESS = 'FETCH_BULK_CASE_UPDATION_LIST_SUCCESS';
export const FETCH_BULK_CASE_UPDATION_LIST_FAILURE = 'FETCH_BULK_CASE_UPDATION_LIST_FAILURE';

export const fetchBulkCaseUpdationList = (params) => ({
    type: FETCH_BULK_CASE_UPDATION_LIST,
    payload: params,
});

export const fetchBulkCaseUpdationListSuccess = (data) => ({
    type: FETCH_BULK_CASE_UPDATION_LIST_SUCCESS,
    data,
});

export const fetchBulkCaseUpdationListFailure = (error) => ({
    type: FETCH_BULK_CASE_UPDATION_LIST_FAILURE,
    error,
});

export const DOWNLOAD_BULK_CASE_UPDATION_FILE = 'DOWNLOAD_BULK_CASE_UPDATION_FILE';
export const DOWNLOAD_BULK_CASE_UPDATION_FILE_SUCCESS = 'DOWNLOAD_BULK_CASE_UPDATION_FILE_SUCCESS';
export const DOWNLOAD_BULK_CASE_UPDATION_FILE_FAILURE = 'DOWNLOAD_BULK_CASE_UPDATION_FILE_FAILURE';

export const downloadBulkCaseUpdationFile = (fileKey) => ({
    type: DOWNLOAD_BULK_CASE_UPDATION_FILE,
    payload: fileKey,
});

export const downloadBulkCaseUpdationFileSuccess = (presignedUrl) => ({
    type: DOWNLOAD_BULK_CASE_UPDATION_FILE_SUCCESS,
    payload: presignedUrl,
});

export const downloadBulkCaseUpdationFileFailure = (error) => ({
    type: DOWNLOAD_BULK_CASE_UPDATION_FILE_FAILURE,
    error,
});